<template>
  <div
    class="item1-content-raw"
  >
    <!--<h3>链接模板</h3>-->

    <template>
      <!-- 原来 -->
      <!--<div-->
      <!--  class="item1"-->
      <!--  v-for="(item) in rawData"-->
      <!--  :key="item.id"-->
      <!--  @click="onClick(item)"-->
      <!--&gt;-->
      <!--  &lt;!&ndash;<i class="iconfont icon-plywood"></i>&ndash;&gt;-->
      <!--  &lt;!&ndash; 图标图片 &ndash;&gt;-->
      <!--  <img-->
      <!--    v-if="getAttachmentByType(2, item.attmentDTOList)"-->
      <!--    class="icon-item"-->
      <!--    :src="'/' + getAttachmentByType(2, item.attmentDTOList)"-->
      <!--    alt=""-->
      <!--  >-->
      <!--  &lt;!&ndash; 文字 &ndash;&gt;-->
      <!--  &lt;!&ndash;<p>{{ item.title }}</p>&ndash;&gt;-->
      <!--  <p v-html="item.title"></p>-->
      <!--</div>-->
      <!-- 修改的 -->
      <div
        v-for="(item) in rawData"
        :key="item.id"
      >
        <!-- :href="'/' + item.attmentDTOList[0].path" -->
        <div
          v-if="item.materialType === 3"
          class="item1"
          @click="confirmMessage(4, item.attmentDTOList)"
        >
          <a style="display: none;"
            :ref="'fileLink' + getAttachmentById(4, item.attmentDTOList)"
            :href="'/' + getAttachmentByType(4, item.attmentDTOList)"
          >代替链接</a>
          <!--<i class="iconfont icon-plywood"></i>-->
          <!-- 图标图片 -->
          <img
            v-if="getAttachmentByType(2, item.attmentDTOList)"
            class="icon-item"
            :src="'/' + getAttachmentByType(2, item.attmentDTOList)"
            alt=""
          >
          <!-- 文字 -->
          <!--<p>{{ item.title }}</p>-->
          <p v-html="item.title"></p>
        </div>
        <div
          v-else
          class="item1"
          @click="onClick(item)"
        >
          <!--<i class="iconfont icon-plywood"></i>-->
          <!-- 图标图片 -->
          <img
            v-if="getAttachmentByType(2, item.attmentDTOList)"
            class="icon-item"
            :src="'/' + getAttachmentByType(2, item.attmentDTOList)"
            alt=""
          >
          <!-- 文字 -->
          <!--<p>{{ item.title }}</p>-->
          <p v-html="item.title"></p>
        </div>
      </div>
    </template>
    <!-- 底部文字 -->
    <p
      class="fxtip"
      v-if="bottomInfo[0]"
    >
      {{ bottomInfo[0] }}
    </p>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    // 数据源
    rawData: Array,
    // 底部信息
    bottomInfo: Array,
    // 跳转函数
    onClick: Function
  },
  data () {
    return {}
  },
  created () {
    console.log('LinkTemplate-raw', this.rawData)
    // console.log('LinkTemplate-info', this.bottomInfo)
  },
  methods: {
    // handleGoTo (item) {
    //   // 素材类型 2 -> 链接
    //   if (item.materialType === 2) {
    //     item.url && (window.location.href = item.url)
    //     // 素材类型 1 -> 图片
    //   } else if (item.materialType === 1) {
    //     // 素材附件 5 -> 长图
    //     let imgUrl = this.getAttachmentByType(5, item.attmentDTOList)
    //     imgUrl && (window.location.href = imgUrl)
    //   }
    //   // window.location.href = 'http://www.Baidu.com'
    // },
    // 获取指定附件类型的 path
    getAttachmentByType (t, attachmentList) {
      // console.log('t', t)
      // console.log('attachmentList', attachmentList)
      for (let e of attachmentList) {
        if (e.attachmentType === t) {
          return e.path
        }
      }
    },
    // 获取指定附件类型的 id
    getAttachmentById (t, attachmentList) {
      for (let e of attachmentList) {
        if (e.attachmentType === t) {
          return e.id
        }
      }
    },
    confirmMessage (attachmentType, attachmentList) {
      let attachmentName
      let attachmentId
      let attachmentPath
      for (let e of attachmentList) {
        if (e.attachmentType === attachmentType) {
          attachmentName = e.name
          attachmentId = e.id
          attachmentPath = e.path
          break
        }
      }
      if (attachmentName) {
        let fileFormat = attachmentName.substr(attachmentName.lastIndexOf('.')).toLowerCase()
        // console.log('fileFormat is: ', fileFormat)
        if (fileFormat === '.pdf' || fileFormat === '.doc' || fileFormat === '.docx' || fileFormat === '.ppt' || fileFormat === '.pptx') {
          this.$nextTick(() => {
            this.$router.push({
              name: 'FileConvertedImage',
              query: {
                attachmentId: attachmentId,
                attachmentPath: attachmentPath,
                title: attachmentName
              }
            })
          })
        } else {
          this.$refs['fileLink' + attachmentId][0].click()
          return false
        }
      }
    }
  }
}
</script>
<style
  lang="scss"
  scoped
>
* {
  box-sizing: border-box;
}

.page {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  height: auto;
  background-color: #efeff1;

  .banner {
    width: 100vw;
    height: 4.853rem;
    //background-color: skyblue;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .container {
    width: 8.84rem;
    //height: 400px;
    padding: 0.467rem 0.2rem;
    margin: 0.48rem 0 0.307rem 0;
    background-color: #FFFFFF;
    border-radius: 0.4rem;
    /* 按钮区 */
    .clBox {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .cl-item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 3.787rem;
        height: 0.96rem;
        margin: 0 0 0.507rem 0;
        font-size: 0.373rem;
        color: #FFFFFF;
        background-color: #2f8cec;
        box-shadow: 0 1px 5px rgba(0, 75, 153, 0.3);
        border-radius: 0.96rem;

        i {
          font-size: 0.64rem; // 24px
          margin: 0 0.267rem 0 0;
        }

        p {
          display: inline-block;
          line-height: 1;
        }
      }
    }

    /* 分隔线 dashed */
    .dashed {
      width: 100%;
      height: 0.027rem;
      border: 0;
    }

    /* 内容区 */
    .item-content {
      width: 100%;
      padding: 0.533rem 0 0 0;
      /* todo 背景颜色 */
      background-color: pink;
      /* 基础材料 */
      .item1-content-raw {
        .item1 {
          display: flex;
          align-items: center;
          width: 100%;
          padding: 0.133rem 0.267rem;
          margin: 0 0 0.293rem 0;
          font-size: 0.373rem;
          color: #FFFFFF;
          background-color: #2f8cec;
          border-radius: 0.267rem;

          /* todo 字体图标 */
          //i {
          //  font-size: 0.533rem;
          //  margin: 0 0.133rem 0 0;
          //}

          .icon-item {
            margin: 0 0.2rem 0 0;
            width: 0.4rem;
          }
        }
      }

      /* 渠道材料 */
      .password-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 6.667rem;
        //background-color: #fff;
        //background: purple;
        .input-password {
          width: 4.4rem;
          height: 1.2rem;
          font-size: 0.533rem;
          color: #7f7f7f;
          text-align: center;
          border: 2px #13346a solid;
          border-radius: 0.2rem;
        }

        .div-confirm {
          width: 4.4rem;
          height: 1.2rem;
          margin: 0.333rem 0 0 0;
          font-size: 0.533rem;
          color: #ffffff;
          text-align: center;
          line-height: 1.173rem;
          background: #13346a;
          border-radius: 0.2rem;
        }
      }

      /* 宣传海报 */
      .poster-container {
        display: flex;
        flex-wrap: wrap;

        .poster-box {
          width: 33.33%;
          display: flex;
          flex-direction: column;

          img {
            width: 2rem;
            height: 2rem;
          }

          p {
            width: 2rem;
            padding: 0.333rem 0 0.333rem 0;
            text-align: center;
          }
        }

        .poster-box:nth-of-type(3n - 1) {
          align-items: center;
        }

        .poster-box:nth-of-type(3n) {
          align-items: flex-end;
        }
      }

      /* 媒体报道 */
      .media-container {
        .media-item {
          display: flex;
          align-items: center;
          width: 100%;
          //height: 0.8rem;
          padding: 0.133rem 0.267rem;
          margin: 0 0 0.293rem 0;
          font-size: 0.373rem;
          color: #FFFFFF;
          background-color: #2f8cec;
          border-radius: 0.267rem;

          i {
            font-size: 0.533rem;
            margin: 0 0.133rem 0 0;
          }
        }
      }
    }
  }
}

/* 底部文字 */
.fxtip {
  width: 100%;
  padding: 0.4rem 0 0;
  text-align: justify;
  //font-size: 0.3rem;
  //line-height: 0.35rem;
  //font-size: 0.1rem;
  font-size: calc(0.14 * 100vw / 7.5);
  line-height: 0.4rem;
  //line-height: calc(0.20 * 100vw / 7.5);
  color: #070707;
}

/* tab 高亮 */
.cl-item-active {
  background-color: #005ebf !important;
  transition: 0.3s;
}

/* 测试 icon 的编写 */
.icon {
}
</style>



// WEBPACK FOOTER //
// src/components/ui/LinkTemplate.vue